import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, ArrowRight, AlertCircle, Check } from 'lucide-react';
import { api, formatApiError } from '../lib/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | ok | err
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setStatus('ok');
    } catch (err) {
      setStatus('err');
      setError(formatApiError(err.response?.data?.detail) || 'Error de red');
    }
  };

  return (
    <div className="grain min-h-screen bg-bg flex items-center justify-center px-5 py-10" data-testid="forgot-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md relative z-10"
      >
        <div className="mb-10 text-center">
          <div className="font-display text-5xl text-ink mb-2">MODARIA</div>
          <div className="text-eyebrow text-ink-muted">Recuperar contraseña</div>
        </div>

        {status === 'ok' ? (
          <div data-testid="forgot-success" className="bg-bg-secondary border border-line rounded-md p-8 md:p-10 text-center">
            <Check className="mx-auto mb-4 text-acid" size={32} />
            <p className="text-ink mb-3">Si el email existe en nuestro sistema, recibirás un enlace para restablecer tu contraseña en menos de 1 minuto.</p>
            <p className="text-ink-muted text-sm">Revisa tu bandeja de entrada y la carpeta de spam.</p>
            <a href="/login" className="text-eyebrow text-ink-muted hover:text-ink mt-6 inline-block">← Volver al login</a>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-7 bg-bg-secondary border border-line rounded-md p-8 md:p-10" data-testid="forgot-form">
            <p className="text-ink-muted text-sm">
              Introduce tu email de admin y te enviaremos un enlace para restablecer tu contraseña.
            </p>
            <div>
              <label className="text-eyebrow mb-1 block flex items-center gap-2">
                <Mail size={12} /> Email
              </label>
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-bare"
                data-testid="forgot-email"
              />
            </div>
            {error && (
              <div className="text-danger text-xs font-mono uppercase tracking-[0.18em] flex items-center gap-2" data-testid="forgot-error">
                <AlertCircle size={14} /> {error}
              </div>
            )}
            <button
              type="submit"
              disabled={status === 'loading'}
              className="btn-acid w-full justify-center disabled:opacity-50"
              data-testid="forgot-submit"
            >
              {status === 'loading' ? 'Enviando…' : (<>Enviar enlace <ArrowRight size={14} /></>)}
            </button>
            <div className="text-center pt-2">
              <a href="/login" className="text-eyebrow text-ink-muted hover:text-ink">← Volver al login</a>
            </div>
          </form>
        )}
      </motion.div>
    </div>
  );
}
